export default __webpack_public_path__ + "static/media/fa-brands-400.31015e86.woff2";